<template>
  <div>
    <footer>
      <div class="app_footer">
        <section>
          <div class="footer_le">
            <img src="./footer_logo.png" alt="">
            <p>让数据更懂你 让推广更简单</p>
          </div>
          <div class="footer_le_about">
            <h4 @click="toabout">关于巨掌</h4>
            <h4 @click="tocontact">联系我们</h4>
            <h4 @click="tojoin">加入我们</h4>
          </div>
          <div class="footer_ri_tel">
            <span>服务热线： 010-56208704</span>
            <span>服务时间： 周一至周五9:30~18:30</span>
            <a href="mailto:juzhang@adjuz.net">邮箱： juzhang@adjuz.net</a>
          </div>
          <div class="footer_ma">
            <!-- <div>
              <img src="./home_ma.jpg" alt="">
              <p>关注巨掌数据</p>
            </div> -->
            <div>
              <img src="./home_ma2.jpg" alt="">
              <p>关注行业资讯</p>
            </div>
            <p class="p">
              <b>中文-简体</b>
              <b @click="English">English</b>
            </p>
          </div>
        </section>
      </div>
      <p class="footer_p">
        ©2012-2030 adjz.com 巨掌互动科技（北京）有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank">京ICP备16035028号</a>
        <!-- <span @click="zengzhi">&nbsp;&nbsp;
          增值电信业务许可证：京B2-20200460 
        </span>-->
        <!-- ©2012-2022 adjuz.net 巨掌互动科技（北京）有限公司 <span @click="beian">&nbsp;&nbsp;京ICP备16035028号-2</span><span @click="zengzhi">&nbsp;&nbsp;
          增值电信业务许可证：京B2-20200460</span> -->
        &nbsp;&nbsp;<span @click="toj"><img src="./j.png">&nbsp;京公网安备11010602007188号</span>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "",

  data() {
    return {};
  },

  props: {},

  components: {},

  computed: {},

  watch: {},

  filters: {},

  created() { },

  updated() { },

  mounted() { },

  destroyed() { },

  methods: {
    English() {
      window.open("https://asa.adjz.com/entrance?lg=en");
    },
    toabout() {
      this.$windowopen({ path: "/about_adjuz" });
    },
    tojoin() {
      this.$windowopen({ path: "/joinus" });
    },
    tocontact() {
      this.$windowopen({ path: "/contactus" });
    },
    beian() {
      window.open("https://beian.miit.gov.cn");
    },
    zengzhi() {
      window.open("https://static.adjuz.net/adjuz-website/ICP证书.jpg");
    },
    toj() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602007188"
      );
    },
  },
};
</script>
<style lang='less' scoped>
footer {
  width: 100%;
  background: #111;

  .footer_p {
    margin-top: 80px;
    height: 80px;
    width: 100%;
    text-align: center;
    line-height: 80px;
    background: #0b0b0b;
    color: #fff;
    border-top: 1px solid #444;

    span,
    a {
      cursor: pointer;
      color: #fff;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.app_footer {
  width: 100%;

  section {
    width: 1200px;
    height: 112px;
    display: flex;
    padding-top: 50px;
    margin: 0 auto;
    position: relative;
    display: flex;
  }

  .footer_le {
    margin-top: 24px;
    width: 26%;

    p {
      margin-top: 6px;
      color: #fff;
    }
  }

  .footer_le_about {
    width: 17%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h4 {
      color: #fff;
      cursor: pointer;
      margin-left: 8px;
    }
  }

  .footer_ri_tel {
    width: 36.6%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    span {
      color: #fff;
    }

    a {
      color: #fff;
    }
  }

  .footer_ma {
    display: flex;
    margin-top: -6px;
    width: 20.4%;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 5px;
    position: relative;

    div {
      img {
        width: 90px;
        height: 90px;
        //border: 5px solid #ccc;
      }

      p {
        text-align: center;
        margin-top: 2px;
        color: #fff;
      }
    }

    .p {
      display: flex;
      position: absolute;
      bottom: -40px;
      left: 0;

      b {
        display: block;
        padding: 3px 10px;
        border: 1px solid #0955be;
        border-radius: 4px;
        cursor: pointer;
        color: #333;
        background: #fff;
        font-size: 12px;

        &:first-child {
          margin-right: 20px;
        }

        &:last-child {
          background: #000;
          color: #fff;
          border: 1px solid #fff;
          transition: all 0.2s;

          &:hover {
            border: 1px solid #0955be;
            color: #333;
            background: #fff;
          }
        }
      }
    }
  }
}</style>
<style lang='less' ></style>



// WEBPACK FOOTER //
// src/components/footer.vue